import Triggerable from "metabase/components/Triggerable";
import Popover from "metabase/components/Popover";

/**
 * @deprecated prefer Popover from "metabase/ui" + useState instead
 */
export default Triggerable(Popover);
